import React, { useState } from "react";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import logo from "../../../../assets/images/logo.png";

import x from "../../../../assets/images/x.png";
import tg from "../../../../assets/images/tg.png";
import {
  MenuLink,
  MobileMainMenu,
  DrawerBox,
  DrawerDivider,
  Humburgger,
  HumburggerClose,
  MenuButton,
} from "../styles";
import { DataImage } from "../../../Styles/style";

const MobileMenu = (props) => {
  const [state, setState] = useState({ left: false });

  const toggleDrawer = (anchor, open) => (event) => {
    console.log("thest: ", anchor + " : " + open);
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };
  return (
    <MobileMainMenu>
      <MenuLink p="10px 0" href="/" sx={{ display: "flex !important" }}>
        <DataImage src={logo} mw="100px" />
      </MenuLink>
      <MenuButton onClick={toggleDrawer("left", true)}>
        {state["left"] ? (
          <HumburggerClose>Close</HumburggerClose>
        ) : (
          <Humburgger></Humburgger>
        )}
      </MenuButton>
      <Drawer
        anchor="left"
        open={state["left"]}
        onClose={toggleDrawer("left", false)}
      >
        <DrawerBox
          role="presentation"
          onClick={toggleDrawer("left", false)}
          onKeyDown={toggleDrawer("left", false)}
        >
          <DrawerDivider>
            <MenuLink href="/">
              <DataImage src={logo} mw="120px" />
            </MenuLink>
            <Divider style={{ background: "#19FB9B" }} />
            <List>
              {props.menuList.map((value, i) => (
                <MenuLink key={i} href={value.link} target={value.target}>
                  {value.title}
                </MenuLink>
              ))}
            </List>
            <div style={{ display: "flex",justifyContent:"center",gap:"20px" }}>
              <MenuLink p="0" href="https://t.me/soldragoncoin" target="blank">
                <DataImage mw="30px" src={tg} />
              </MenuLink>
              <MenuLink p="0" href="https://twitter.com/soldragoncoin" target="blank">
                <DataImage mw="30px" src={x} />
              </MenuLink>
            </div>
          </DrawerDivider>
        </DrawerBox>
      </Drawer>
    </MobileMainMenu>
  );
};

export default MobileMenu;
